module.exports = __webpack_public_path__ + "200a1e1e7667de34a6182978b33e17a7.png";